import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getPcMainScrollElement } from "./main-simplebar.js";

gsap.registerPlugin(ScrollTrigger);

/** PC（768px〜）では SimpleBar の実スクロール要素。ScrollTrigger の scroller に渡す */
function getScrollTriggerScroller() {
  return getPcMainScrollElement();
}

/** お悩みビジュアルの吹き出しゆらぎ（TOP / サービス共通） */
function worryBubbleWobbleReduceMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function playWorryBubbleWobble(bubbleEl) {
  if (!bubbleEl || worryBubbleWobbleReduceMotion()) return;
  gsap.killTweensOf(bubbleEl);
  gsap.set(bubbleEl, { rotation: 0, transformOrigin: '52% 55%', force3D: true });
  gsap.to(bubbleEl, {
    keyframes: [
      { rotation: -5, duration: 0.12, ease: 'sine.out' },
      { rotation: 4.5, duration: 0.13, ease: 'sine.inOut' },
      { rotation: -3, duration: 0.11, ease: 'sine.inOut' },
      { rotation: 2, duration: 0.09, ease: 'sine.inOut' },
      { rotation: 0, duration: 0.25, ease: 'sine.out' },
    ],
  });
}

function bindWorryBubbleScrollWobble(bubbleEl) {
  if (!bubbleEl) return;
  const scroller = getScrollTriggerScroller();
  var play = function () {
    playWorryBubbleWobble(bubbleEl);
  };
  ScrollTrigger.create({
    trigger: bubbleEl,
    start: 'top 50%',
    ...(scroller ? { scroller: scroller } : {}),
    onEnter: play,
    onEnterBack: play,
  });
}

/** サービス: お悩みカードがビューに入るたび右→左へスライドイン（離脱で初期位置に戻して再入場で再生） */
function bindSvcWorriesCardsSlideIn() {
  var cards = document.querySelectorAll('.svcWorries__cards .svcWorries__card');
  if (!cards.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  for (var i = 0; i < cards.length; i++) {
    (function (card) {
      var runSlideIn = function () {
        gsap.killTweensOf(card);
        gsap.fromTo(
          card,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetCard = function () {
        gsap.killTweensOf(card);
        gsap.set(card, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: card,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetCard,
        onLeaveBack: resetCard,
      });
    })(cards[i]);
  }
}

/** TOP不安カード: ビュー到達で右→左スライドイン（離脱でリセットして再入場で再生） */
function bindTopAnxietyCardsSlideIn() {
  var cards = document.querySelectorAll('#anxiety .topAnxiety__card');
  if (!cards.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  for (var i = 0; i < cards.length; i++) {
    (function (card) {
      gsap.set(card, { x: 48, opacity: 0 });
      var runSlideIn = function () {
        gsap.killTweensOf(card);
        gsap.fromTo(
          card,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetCard = function () {
        gsap.killTweensOf(card);
        gsap.set(card, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: card,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetCard,
        onLeaveBack: resetCard,
      });
    })(cards[i]);
  }
}

/** サービス詳細カード: 悩み白ボックス全体が到達時に右→左へスライドイン（離脱でリセット） */
function bindSvcDetailWorriesSlideIn() {
  var boxes = document.querySelectorAll('.svcDetailCard__worriesBox');
  if (!boxes.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  var b;
  for (b = 0; b < boxes.length; b++) {
    (function (box) {
      var runSlideIn = function () {
        gsap.killTweensOf(box);
        gsap.fromTo(
          box,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetBox = function () {
        gsap.killTweensOf(box);
        gsap.set(box, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: box,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetBox,
        onLeaveBack: resetBox,
      });
    })(boxes[b]);
  }
}

/** サービス「運用の透明性」: 各カード全体が到達時に右→左へスライドイン（離脱でリセット） */
function bindSvcSystemCardsSlideIn() {
  var cards = document.querySelectorAll('.svcSystem__card');
  if (!cards.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  var c;
  for (c = 0; c < cards.length; c++) {
    (function (card) {
      var runSlideIn = function () {
        gsap.killTweensOf(card);
        gsap.fromTo(
          card,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetCard = function () {
        gsap.killTweensOf(card);
        gsap.set(card, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: card,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetCard,
        onLeaveBack: resetCard,
      });
    })(cards[c]);
  }
}

/** サービス料金: カード類をビュー到達で右→左スライドイン（指示書「サービス_料金」） */
function bindSvcFeeCardsSlideIn() {
  var cards = document.querySelectorAll(
    '#price .svcFee__base, #price .svcFee__extra, #price .svcFee__freeBox, #price .svcFee__bundleCard'
  );
  if (!cards.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  var i;
  for (i = 0; i < cards.length; i++) {
    (function (card) {
      gsap.set(card, { x: 48, opacity: 0 });
      var runSlideIn = function () {
        gsap.killTweensOf(card);
        gsap.fromTo(
          card,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetCard = function () {
        gsap.killTweensOf(card);
        gsap.set(card, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: card,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetCard,
        onLeaveBack: resetCard,
      });
    })(cards[i]);
  }
}

/**
 * セクション区切りライン: 左右ドットが V 線上を中央へ（Figma 5:395 → 38:1395）
 * 到達時に一度再生。スクロールで戻してもドットは中央のまま。
 */
function bindSecLineDots() {
  var lines = document.querySelectorAll('.js-sec-line');
  if (!lines.length) return;

  var L0 = { x: 0.145, y: 0.479 };
  var R0 = { x: 390.145, y: 0.479 };
  var C = { x: 195.145, y: 59.479 };
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scroller = getScrollTriggerScroller();
  var i;

  for (i = 0; i < lines.length; i++) {
    (function (line) {
      var dotL = line.querySelector('.js-sec-line-dotL');
      var dotR = line.querySelector('.js-sec-line-dotR');
      if (!dotL || !dotR) return;

      if (reduceMotion) {
        gsap.set(dotL, { attr: { cx: C.x, cy: C.y } });
        gsap.set(dotR, { attr: { cx: C.x, cy: C.y } });
        return;
      }

      gsap.set(dotL, { attr: { cx: L0.x, cy: L0.y } });
      gsap.set(dotR, { attr: { cx: R0.x, cy: R0.y } });

      ScrollTrigger.create({
        trigger: line,
        start: 'top 75%',
        once: true,
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: function () {
          gsap
            .timeline({ defaults: { ease: 'power2.out', duration: 0.85 } })
            .to(dotL, { attr: { cx: C.x, cy: C.y } }, 0)
            .to(dotR, { attr: { cx: C.x, cy: C.y } }, 0);
        },
      });
    })(lines[i]);
  }
}

/** サービス: スケジュール破線をスクロール量に合わせて上から伸ばす（Figma 203:1168 / 203:1170） */
function bindSvcScheduleLineGrow() {
  var timeline = document.querySelector('#schedule .svcSchedule__timeline');
  if (!timeline) return;
  var line = timeline.querySelector('.svcSchedule__line');
  if (!line) return;

  var faces = timeline.querySelectorAll('.svcSchedule__face');
  if (faces.length < 2) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scroller = getScrollTriggerScroller();

  var measure = function () {
    var first = faces[0];
    var last = faces[faces.length - 1];
    var tRect = timeline.getBoundingClientRect();
    var fRect = first.getBoundingClientRect();
    var lRect = last.getBoundingClientRect();
    var top = fRect.top - tRect.top + fRect.height * 0.5;
    var maxH = Math.max(0, lRect.top - tRect.top + lRect.height * 0.5 - top);
    line.style.top = top + 'px';
    line.style.left = fRect.left - tRect.left + fRect.width * 0.5 + 'px';
    return maxH;
  };

  if (reduceMotion) {
    line.style.height = measure() + 'px';
    return;
  }

  gsap.fromTo(
    line,
    { height: 15 },
    {
      height: function () {
        return measure();
      },
      ease: 'none',
      scrollTrigger: {
        trigger: timeline,
        start: 'top 60%',
        end: 'bottom 45%',
        scrub: 0.4,
        invalidateOnRefresh: true,
        ...(scroller ? { scroller: scroller } : {}),
      },
    }
  );
}

/** TOP対応エリア: 外側リングを 21→46 に拡大（特定位置到達で再生 / Figma 5:638 → 22:120） */
function bindAreaMapPinExpand() {
  var areaMap = document.querySelector('#area .topArea__map');
  if (!areaMap) return;
  var outers = areaMap.querySelectorAll('.topArea__pinOuter');
  if (!outers.length) return;

  var scaleActive = 46 / 21;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scroller = getScrollTriggerScroller();
  var visual = document.querySelector('#area .topArea__visual') || areaMap;

  if (reduceMotion) {
    gsap.set(outers, { scale: scaleActive, transformOrigin: '50% 50%' });
    return;
  }

  gsap.set(outers, { scale: 1, transformOrigin: '50% 50%' });

  ScrollTrigger.create({
    trigger: visual,
    start: 'top 48%',
    ...(scroller ? { scroller: scroller } : {}),
    onEnter: function () {
      gsap.to(outers, {
        scale: scaleActive,
        duration: 2.2,
        ease: 'power1.out',
        overwrite: 'auto',
      });
    },
    onLeaveBack: function () {
      gsap.killTweensOf(outers);
      gsap.set(outers, { scale: 1, transformOrigin: '50% 50%' });
    },
  });
}

/** TOP対応エリア: 車キャラを右端から左へ 200px（特定位置到達で再生） */
function bindAreaCarSlideIn() {
  var car = document.querySelector('#area .topArea__car');
  var carImg = document.querySelector('#area .topArea__carImg');
  var target = car || carImg;
  if (!target) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scroller = getScrollTriggerScroller();
  var visual = document.querySelector('#area .topArea__visual') || target;
  var xEnd = -342; // Figma 38:1358 x:364 → 38:1360 x:22

  if (reduceMotion) {
    gsap.set(target, { x: xEnd });
    return;
  }

  gsap.set(target, { x: 0, force3D: true });

  ScrollTrigger.create({
    trigger: visual,
    start: 'top 48%',
    ...(scroller ? { scroller: scroller } : {}),
    onEnter: function () {
      gsap.to(target, {
        x: xEnd,
        duration: 2.6,
        ease: 'power1.out',
        overwrite: 'auto',
      });
    },
    onLeaveBack: function () {
      gsap.killTweensOf(target);
      gsap.set(target, { x: 0 });
    },
  });
}

$(window).on("load", function () {

  // MV 全体をページ読み込み完了後にフェードイン（各ページのヒーロー一括）
  if (
    $('body').hasClass('p-top') ||
    $('body').hasClass('p-service') ||
    $('body').hasClass('p-company') ||
    $('body').hasClass('p-contact')
  ) {
    $('body').addClass('is-mvShown');
  }

  // TOP: MV フェード後 — 装飾ラインは CSS（.is-active で 40px ギャップが縦にループ）
  if ($('body').hasClass('p-top')) {
    var reduceDeco = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceDeco) {
      var decoLineEl = document.querySelector('.topMv__decoLine');
      if (decoLineEl) {
        window.setTimeout(function () {
          decoLineEl.classList.add('is-active');
        }, 900);
      }
    }
  }

  var secCount = $('.js-sec-count').length +1;
  let sectionItem
  let navItem

  // for (let i = 1; i < 6; i++) {
  for (let i = 1; i < secCount; i++) {
    navItem = '.js-current-nav' + i
    sectionItem = '.js-current-sec' + i
    const navScroller = getScrollTriggerScroller();
    ScrollTrigger.create({
      trigger: sectionItem,
      start: 'top center',
      end: 'bottom center',
      ...(navScroller ? { scroller: navScroller } : {}),
      toggleClass: {
        targets: navItem,
        className: 'is-current',
      },
    });
  }

  if ($('body').hasClass('p-top') || $('body').hasClass('p-service')) {
    ScrollTrigger.refresh();
  }

  let stResizeTimer;
  $(window).on("resize", function () {
    clearTimeout(stResizeTimer);
    stResizeTimer = setTimeout(function () {
      ScrollTrigger.refresh();
    }, 250);
  });

  // 会社概要: 沿革タイムラインの縦線を上から下へ（Figma 264:3018 / 264:3059）
  const historyTimeline = document.querySelector('#company-history .cmpHistory__timeline');
  if (historyTimeline) {
    let historyLinePlayed = false;
    const histScroller = getScrollTriggerScroller();
    ScrollTrigger.create({
      trigger: '#company-history',
      start: 'top 82%',
      ...(histScroller ? { scroller: histScroller } : {}),
      onEnter: () => {
        if (historyLinePlayed) return;
        historyLinePlayed = true;
        historyTimeline.classList.add('is-lineVisible');
      },
    });
  }

  // 対応エリア: 地図ピン外側リング 21→46（Figma 5:638 → 22:120）をスクロールに合わせて拡大
  bindAreaMapPinExpand();
  // 対応エリア: 車キャラを右からゆっくりスライドイン（Figma 38:1358）
  bindAreaCarSlideIn();

  // お悩み吹き出し: ビューに入るたびゆらぎ（下方向スクロール・上方向スクロールの再入場の両方）
  bindWorryBubbleScrollWobble(document.querySelector('.topWorries__bubble'));
  bindWorryBubbleScrollWobble(document.querySelector('.svcWorries__bubble'));

  bindTopAnxietyCardsSlideIn();
  bindSvcWorriesCardsSlideIn();
  bindSvcDetailWorriesSlideIn();
  bindSvcSystemCardsSlideIn();
  bindSvcFeeCardsSlideIn();
  bindSecLineDots();
  bindSvcScheduleLineGrow();
  if ($('body').hasClass('p-service')) {
    ScrollTrigger.refresh();
  }
});
